$ = require 'jquery'
React = require 'react'
ReactDOM = require 'react-dom'
UserInput = require 'views/internal/user-input'
_ = require 'underscore'

module.exports = class extends React.Component
  displayName: "Wrapper"

  componentWillMount: ->
    # Trigger a data load
    @props.view.getData?()

  componentDidMount: ->

    node = ReactDOM.findDOMNode(this)

    el = @props.view.render().el

    $(node).append(el)

    UserInput.addHandler @props.view,
      scope: if @props.scope then @props.scope else 'popover_view'

  componentWillUnmount: ->
    UserInput.removeHandler(@props.view)

  render: ->
    return React.createElement 'div', _.pick(@props, [
      'className'
    ])



// WEBPACK FOOTER //
// ./app/scripts/lib/react/backbone-view-wrapper.coffee